<template>
  <div>
    <b-row class="row-align-left">
      <b-col sm="12" lg="6">
        <label for="radios8">
          Do you have health coverage through an employer, government or private
          health insurance? Government insurance includes Medicare, Medicaid,
          Palm Beach County Health Care District, TRICARE, or CHAMPVA (Veterans
          Administration)?
        </label>
      </b-col>
      <b-col sm="12" lg="6">
        <b-row>
          <b-col md="4">
            <label class="float-left">
              <input
                type="radio"
                class="option-input radio"
                :class="{ 'invalid-radio-button': haveHealthCoverageState }"
                name="rd7"
                value="1"
                v-model="$v.haveHealthCoverage.$model"
              >
              Yes
            </label>
          </b-col>
          <b-col md="4">
            <label class="float-left">
              <input
                type="radio"
                class="option-input radio"
                :class="{ 'invalid-radio-button': haveHealthCoverageState }"
                name="rd7"
                value="0"
                v-model="$v.haveHealthCoverage.$model"
              >
              No
            </label>
          </b-col>
          <b-col md="4">
            <label class="float-left">
              <input
                type="radio"
                class="option-input radio"
                :class="{ 'invalid-radio-button': haveHealthCoverageState }"
                name="rd7"
                value="2"
                v-model="$v.haveHealthCoverage.$model"
              >
              Uncertain
            </label>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <hr>
    <b-row class="row-align-left">
      <b-col sm="7">
        <label for>Name of Health Insurance Plan or Health Care Clinic</label>
      </b-col>
      <b-col sm="5">
        <b-form-input
          placeholder="name"
          v-model.trim="healthInsurancePlanName"
          :state="healthInsurancePlanNameState"
        ></b-form-input>
      </b-col>
    </b-row>
    <hr>
    
    <b-row class="row-align-left">
      <b-col sm="12" lg="6">
        <label for="radios8">
          If you do not have health coverage, would you like to be contacted about health coverage options and/or programs you may be eligible for? 
        </label>
      </b-col>
      <b-col sm="12" lg="6">
        <b-row>
          <b-col md="4">
            <label class="float-left">
              <input
                type="radio"
                class="option-input radio"
                :class="{ 'invalid-radio-button': contactForHealthCoverageState }"
                name="rd8"
                value="1"
                v-model="$v.contactForHealthCoverage.$model"
              >
              Yes
            </label>
          </b-col>
          <b-col md="4">
            <label class="float-left">
              <input
                type="radio"
                class="option-input radio"
                :class="{ 'invalid-radio-button': contactForHealthCoverageState }"
                name="rd8"
                value="0"
                v-model="$v.contactForHealthCoverage.$model"
              >
              No
            </label>
          </b-col>
          <b-col md="4">
            <label class="float-left">
              <input
                type="radio"
                class="option-input radio"
                :class="{ 'invalid-radio-button': contactForHealthCoverageState }"
                name="rd8"
                value="2"
                v-model="$v.contactForHealthCoverage.$model"
              >
              N/A
            </label>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <survey-nav
      :step="6"
      :ShowErrorMsg="showErrorMsg"
      @move-next="moveNext"
      @move-previous="movePrevious"
    ></survey-nav>
  </div>
</template>

<script>
import surveyNav from "@/components/SurveyNav";
import { required } from "vuelidate/lib/validators";

export default {
  name: "survey-step6",
  props: ["surveyData", "isValid"],
  data: () => ({
    contactForHealthCoverage: null,
    healthInsurancePlanName: null,
    haveHealthCoverage: null,
    showErrorMsg: false
  }),
  validations: {
    contactForHealthCoverage: {
      required
    },
    haveHealthCoverage: {
      required
    },
    // havePrimaryDoctor: {
    //   required
    // },
    // followUpResults: {
    //   required
    // }    
  },
  components: {
    surveyNav
  },
  methods: {
    moveNext() {
      if (this.validateForm()) {
          this.$emit("move-next");
          }
      else {
        this.showErrorMsg = true;
        this.$v.$touch();
      }
    },
    movePrevious() {
      this.$emit("move-previous");
    },
    onCreated() {
      // this.followUpResults = this.surveyData.FollowUpResults;
      // this.havePrimaryDoctor = this.surveyData.HavePrimaryDoctor;
      this.healthInsurancePlanName = this.surveyData.HealthInsurancePlanName;
      this.haveHealthCoverage = this.surveyData.HaveHealthCoverage;
      this.contactForHealthCoverage = this.surveyData.ContactForHealthCoverage;
    },
    validateForm() {
      if(this.$v.$invalid) return false;
      if(this.haveHealthCoverage === "1" && this.healthInsurancePlanName === '') return false;
      return true;
    }
  },
  computed: {
    haveHealthCoverageState() {
      return this.$v.haveHealthCoverage.$dirty
        ? !this.$v.haveHealthCoverage.required
        : null;
    },
    healthInsurancePlanNameState(){
      if(this.haveHealthCoverage === "1"){
        if (!this.healthInsurancePlanName) return false;
        return true;
      }
      else {
        return null;
      }
    },
    contactForHealthCoverageState() {
      return this.$v.contactForHealthCoverage.$dirty
        ? !this.$v.contactForHealthCoverage.required
        : null;
    },
    // havePrimaryDoctorState() {
    //   return this.$v.havePrimaryDoctor.$dirty
    //     ? !this.$v.havePrimaryDoctor.required
    //     : null;
    // }
    // healthInsurancePlanNameState() {
    //   console.log(this.haveHealthCoverage);
    //   return this.$v.healthInsurancePlanName.$dirty ? !this.$v.healthInsurancePlanName.required : null;
    //   // if (this.haveHealthCoverage === 1) {
    //   //   return this.$v.healthInsurancePlanName.$dirty
    //   //     ? !this.healthInsurancePlanName.required
    //   //     : null;
    //   // }
    //   // return null;
    // }
  },
  watch: {
    contactForHealthCoverage() {
      if (this.$v.contactForHealthCoverage.required)
        this.surveyData.ContactForHealthCoverage = this.contactForHealthCoverage;
    },
    // havePrimaryDoctor() {
    //   if (this.$v.havePrimaryDoctor.required)
    //     this.surveyData.HavePrimaryDoctor = this.havePrimaryDoctor == "true";
    // },
    healthInsurancePlanName() {
      if (this.healthInsurancePlanName)
        this.surveyData.HealthInsurancePlanName = this.healthInsurancePlanName;
    },
    haveHealthCoverage() {
      if (this.$v.haveHealthCoverage.required)
        this.surveyData.HaveHealthCoverage = this.haveHealthCoverage;
    }
  },
  created() {
    this.onCreated();
  }
};
</script>
